export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7276.216fac1c.jpg";